module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/216-england-3fda5044336aa1a7b3e6ed89f41564c3.svg";